import { gql } from "@/gql";

export const CREATE_DISCOUNT = gql(`
  mutation CreateDiscount($salonId: ID!, $input: CreateDiscountInput!) {
    createDiscount(salonId: $salonId, input: $input) {
      discount {
        id
        name
        code
        scope
        couponType
        isActive
        autoApply
        conditions {
          minSpent
          timeCondition {
            activePeriod {
              startDatetime
              endDatetime
            }
            targetedPeriod {
              startDatetime
              endDatetime
              offPeakHours {
                dayOfWeek
                timeRanges
              }
            }
          }
        }
        rules {
          applyTo
          items {
            valueType
            value
            target {
              type
              serviceIds
            }
          }
        }
        createdAt
        updatedAt
      }
      code
      message
    }
  }
`);

export const UPDATE_DISCOUNT = gql(`
  mutation UpdateDiscount($salonId: ID!, $discountId: ID!, $input: UpdateDiscountInput!) {
    updateDiscount(salonId: $salonId, discountId: $discountId, input: $input) {
      id
      name
      code
      scope
      couponType
      isActive
      autoApply
      conditions {
        minSpent
        timeCondition {
          activePeriod {
            startDatetime
            endDatetime
          }
          targetedPeriod {
            startDatetime
            endDatetime
            offPeakHours {
              dayOfWeek
              timeRanges
            }
          }
        }
      }
      rules {
        applyTo
        items {
          valueType
          value
          target {
            type
            serviceIds
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_DISCOUNT = gql(`
  mutation DeleteDiscount($salonId: ID!, $discountId: ID!) {
    deleteDiscount(salonId: $salonId, discountId: $discountId)
  }
`);
